module.exports = __webpack_public_path__ + "img/reset-password-mobile-fr.bf50cb14.jpg";